import React from 'react';
import { Modal } from '../common/modal';
import { Board } from './Board';
import { Result } from './Result';
import { gameProgressState } from '../../state';
import { useRecoilState } from 'recoil';
import styled from 'styled-components';

const StyledBox = styled.div`
  background-color: transparent;
  width:97%;
  margin:auto;
  height: 254px;
  padding:10px;
  position: relative;
  overflow-x: auto;
  white-space: nowrap;
`;

const Game = () => {
  const [gameProgress, setGameProgress] = useRecoilState(gameProgressState);

  return (
    <>
      {
        (gameProgress !== 'home') && (
          <Board />
        )
      }
      <Modal show={gameProgress === 'intro'} >
        <h2 className="intro-title">遊戲說明</h2>
        <p>
        2020年倒數計時<br />
        回顧這一年，面對疫情衝擊<br />
        我們堅強如昔，維持生活如常<br /><br />
        這一年大家都辛苦了！<br />
        迎接2021，你是否有什麼新年新希望呢？<br /><br />
        Home Run Taiwan 邀請你<br />
        明年給自己一個目標<br />
        <span className="intro-green">「一起來為臺灣做一件好事吧！」</span><br /><br />
        一個人的力量雖然微小<br />
        但一群人凝聚的能量將無比強大<br />
        讓良善的種子，遍撒我們所深愛的臺灣<br /><br />
        快來測測看你是怎樣特質的人<br />
        以及你可以做什麼樣有趣的好事唷！<br />
        </p>
        <div>
        <button onClick={() => setGameProgress('intro2')} className="intro-botton">Next</button>
        </div>
        <div className="separator-transparent">　</div>
      </Modal>
      <Modal show={gameProgress === 'intro2'} onClose={() => setGameProgress('main')}>
      <h2 className="intro-title">遊戲說明</h2>
        <p>
          桌上有 10 張卡片<br />
          請在 15 秒內<br />
          依照你的直覺選出 3 張卡片<br />
        </p>
        <button onClick={() => setGameProgress('main')} className="intro-botton">Start</button>
      </Modal>
      <Modal show={gameProgress === 'result'}>
        <Result />
      </Modal>
      <Modal show={gameProgress === 'education'} onClose={() => setGameProgress('result')}>
      <h2><span className="result-title-type">優質教育型</span><br />
      你可以這樣做！</h2>
      <div className="result-table">
            <div className="result-table-inside" >
              身為優質教育人的你，<br />
              認同這項百年樹人的事業，<br />
              需要有更多有志之士一同努力，<br />
              新的一年，或許可以踏出第一步，<br />
              為臺灣的教育出一份力！<br /><br />
              </div>
            <div className="result-table-inside">
              你可以：<br /><br />
              <span className="result-lable">#參與相關活動與工作</span><br />
              <span className="result-lable">#擔任相關教育志工</span><br />
              <span className="result-lable">#在社群媒體上分享倡議</span>
        </div>
      </div>
      <hr size="8px" align="center" width="60%" color="#e4e4e4"></hr>
      <h4>Home Run Taiwan<br />
      報導教育好人好事：</h4>
      <StyledBox>
      <a href="https://homeruntaiwan.com/detail/article/983" target="_blank" rel="noreferrer"><img src="img/result/edu001.png" className="result-img" alt='result'/></a>
      <a href="https://facebook.com/watch/?v=659961214718641" target="_blank" rel="noreferrer"><img src="img/result/edu002.png" className="result-img" alt='result'/></a>
      <a href="https://homeruntaiwan.com/detail/article/905" target="_blank" rel="noreferrer"><img src="img/result/edu003.png" className="result-img" alt='result'/></a>
      </StyledBox>
      </Modal>
      <Modal show={gameProgress === 'environment'} onClose={() => setGameProgress('result')}>
      <h2><span className="result-title-type">環境保育型</span><br />
      你可以這樣做！</h2>
      <div className="result-table">
            <div className="result-table-inside" >
            身為環境保育人的你，<br />
            有一顆熱愛大自然和動植物的心<br />
            新的一年，或許可以踏出第一步，<br />
            為臺灣的環境保育出一份力！<br /><br />
            </div>
            <div className="result-table-inside" >
              你可以：<br /><br />
              <span className="result-lable">#捐款給環境保育相關組織</span><br />
              <span className="result-lable">#購買生態友善的農產品</span><br />
              <span className="result-lable">#淨灘</span><span className="result-lable">#減少垃圾量</span>
        </div>
    </div>
      <hr size="8px" align="center" width="60%" color="#e4e4e4"></hr>
      <h4>Home Run Taiwan<br />
      報導環境保育好人好事：</h4>
      <StyledBox>
      <a href="https://homeruntaiwan.com/article/view/detail/7" target="_blank" rel="noreferrer"><img src="img/result/env001.png" className="result-img" alt='result'/></a>
      <a href="https://homeruntaiwan.com/detail/article/1063" target="_blank" rel="noreferrer"><img src="img/result/env002.png" className="result-img" alt='result'/></a>
      <a href="https://homeruntaiwan.com/detail/article/935" target="_blank" rel="noreferrer"><img src="img/result/env003.png" className="result-img" alt='result'/></a>
      </StyledBox>
      </Modal>
      <Modal show={gameProgress === 'life'} onClose={() => setGameProgress('result')}>
      <h2><span className="result-title-type">永續生活型</span><br />
      你可以這樣做！</h2>
      <div className="result-table">
            <div className="result-table-inside" >
            身為永續生活人的你，<br />
            開始思考氣候變遷<br />
            對人類和地球帶來的影響，<br />
            希望可以從自身開始，<br />
            成為改變現況的力量<br />
            新的一年，或許可以踏出第一步，<br />
            為臺灣的永續生活出一份力！<br /><br />
            </div>
            <div className="result-table-inside" >
              你可以：<br /><br />
              <span className="result-lable">#減少使用一次性產品</span><br />
              <span className="result-lable">#減少垃圾量</span><span className="result-lable">#購買二手產品</span><br />
              <span className="result-lable">#攜帶餐盒外帶</span><span className="result-lable">#捐贈舊衣</span>
              </div>
        </div>
      <hr size="8px" align="center" width="60%" color="#e4e4e4"></hr>
      <h4>Home Run Taiwan<br />
      報導永續生活好人好事：</h4>
      <StyledBox>
      <a href="https://homeruntaiwan.com/detail/article/948" target="_blank" rel="noreferrer"><img src="img/result/sus001.png" className="result-img" alt='result'/></a>
      <a href="https://www.facebook.com/watch/?v=3468079583213114" target="_blank" rel="noreferrer"><img src="img/result/sus002.png" className="result-img" alt='result'/></a>
      <a href="https://homeruntaiwan.com/article/view/detail/99" target="_blank" rel="noreferrer"><img src="img/result/sus003.png" className="result-img" alt='result'/></a>
      </StyledBox>
      </Modal>
      <Modal show={gameProgress === 'society'} onClose={() => setGameProgress('result')}>
      <h2><span className="result-title-type">社會福祉型</span><br />
      你可以這樣做！</h2>
      <div className="result-table">
            <div className="result-table-inside" >
            身為社會福祉人的你，<br />
            有一顆善良的心，<br />
            關注社會上每個角落的群體<br />
            新的一年，或許可以踏出第一步，<br />
            為臺灣的社會福祉出一份力！<br /><br />
            </div>
            <div className="result-table-inside" >
              你可以：<br /><br />
              <span className="result-lable">#在社群媒體上分享相關資訊</span><br />
              <span className="result-lable">#加入相關組織</span><span className="result-lable">#參與義賣活動</span><br />
              <span className="result-lable">#捐款</span><span className="result-lable">#擔任關懷據點志工</span>
              </div>
        </div>
      <hr size="8px" align="center" width="60%" color="#e4e4e4"></hr>
      <h4>Home Run Taiwan<br />
      報導社會福祉好人好事：</h4>
      <StyledBox>
      <a href="https://homeruntaiwan.com/detail/article/757" target="_blank" rel="noreferrer"><img src="img/result/soc001.png" className="result-img" alt='result'/></a>
      <a href="https://homeruntaiwan.com/detail/article/1059" target="_blank" rel="noreferrer"><img src="img/result/soc002.png" className="result-img" alt='result'/></a>
      <a href="https://homeruntaiwan.com/detail/article/959" target="_blank" rel="noreferrer"><img src="img/result/soc003.png" className="result-img" alt='result'/></a>
      </StyledBox>
      </Modal>
      <Modal show={gameProgress === 'land'} onClose={() => setGameProgress('result')}>
      <h2><span className="result-title-type">土地文化型</span><br />
      你可以這樣做！</h2>
      <div className="result-table">
            <div className="result-table-inside" >
            身為土地文化人的你，<br />
            對於腳踩的這片土地擁有深厚的情感，<br />
            也對臺灣這座島嶼上的人事物富有熱愛<br />
            新的一年，或許可以踏出第一步，<br />
            為臺灣的社會福祉出一份力！<br /><br />
            </div>
            <div className="result-table-inside" >
              你可以：<br /><br />
              <span className="result-lable">#在社群媒體上分享相關資訊</span><br />
              <span className="result-lable">#參加在地小旅行</span><span className="result-lable">#購買在地特產</span><br />
              <span className="result-lable">#挖掘自己鄉鎮特色</span>
              </div>
        </div>
      <hr size="8px" align="center" width="60%" color="#e4e4e4"></hr>
      <h4>Home Run Taiwan<br />
      報導土地文化好人好事：</h4>
      <StyledBox>
      <a href="https://facebook.com/watch/?v=357755375548493" target="_blank" rel="noreferrer"><img src="img/result/loc001.png" className="result-img" alt='result'/></a>
      <a href="https://homeruntaiwan.com/detail/article/839" target="_blank" rel="noreferrer"><img src="img/result/loc002.png" className="result-img" alt='result'/></a>
      <a href="https://homeruntaiwan.com/detail/article/988" target="_blank" rel="noreferrer"><img src="img/result/loc003.png" className="result-img" alt='result'/></a>
      </StyledBox>

      </Modal>
    </>
  );
};

export {
  Game
}
